'use client';

import React from 'react';
import { Header } from './sections/Header';
import { Hero } from './sections/Hero';
import { Problem } from './sections/Problem';
import { Belief } from './sections/Belief';
import { HowItWorks } from './sections/HowItWorks';
// Proof (pedigree) temporarily hidden — to be re-enabled with final images + project list.
// import { Proof } from './sections/Proof';
import { Story } from './sections/Story';
// Demo (proof-in-action) temporarily hidden — to be re-enabled with the live showcase.
// import { Demo } from './sections/Demo';
import { Contact } from './sections/Contact';
import { Footer } from './sections/Footer';

/**
 * PHLD.ai — single refined page. Composes the system sections and runs the
 * scroll-reveal (sections fade + rise once; respects prefers-reduced-motion).
 */
export default function PhldSite() {
  React.useEffect(() => {
    const sections = Array.from(document.querySelectorAll('main > section')).slice(1);
    sections.forEach((s) => s.classList.add('phld-reveal'));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);

  return (
    <div style={{ background: 'var(--surface-canvas)', minHeight: '100vh' }}>
      <Header />
      <main>
        <Hero />
        <Problem />
        <Belief />
        <HowItWorks />
        {/* <Proof /> temporarily hidden — re-enable with final images + project list */}
        <Story />
        {/* <Demo /> temporarily hidden — re-enable with the live showcase */}
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
